import { connectRedux } from '@om1/platform-utils'
import { get } from 'lodash'
import { CohortState, cohortBlocksEditActions, datasetsActions } from '../../../state'
import { NetworkDialogComponent } from './NetworkDialogComponent'

function getNetworkColumnName(name: string) {
    return name.toLowerCase().replace('[beta]', '').trim().replace(/\s+/g, '_').toUpperCase()
}

export function createNetworkDialog<TState extends { cohort: CohortState }>() {
    return connectRedux(
        NetworkDialogComponent,
        (state: TState) => {
            // Filter datasets to only include those with "Network" in their name
            const allDatasets = get(state.cohort.datasets, 'data', [])
            const networkDatasets = allDatasets
                .filter((dataset: any) => dataset.name && dataset.name.toLowerCase().includes('network'))
                .map((dataset: any) => ({
                    id: dataset.id,
                    name: dataset.name,
                    columnName: getNetworkColumnName(dataset.name)
                }))

            return {
                networkDatasets,
                datasetsLoading: get(state.cohort.datasets, 'ui.loading', false)
            }
        },
        { ...cohortBlocksEditActions, ...datasetsActions }
    )
}

export type NetworkDialog = ReturnType<typeof createNetworkDialog>
